import React, { useState } from "react";
import PropertyCard from "./PropertyCard";
import "./AllProperties.css";
import Tulsi1 from "./Images/tulsi1.jpg";
import Satyam from "./Images/Satyam7.jpeg";
import Nilkanth from "./Images/Nilkanth1.jpeg";
import Golden from "./Images/Golden1.jpeg";
import { FaFilter, FaSortAmountDown, FaList, FaSearch } from "react-icons/fa";
import { Helmet } from "react-helmet-async";
// Enhanced properties data with more details
const properties = [
  {
    id: 101,
    areaLocation: " Patiya Ankleshwar",
    title: "Tulsi Patra 3 BHK",
    location: "Gadkhol Patiya Opp:Aiyappa manidr, Ankleshwar",
    image: Tulsi1,
    type: "For Sale",
    isFeatured: true,
    imageCount: 3,
    listedDate: "2026-05-24",
    viewCount: 4250,
    propertyType: "residential",
    beds: 4,
    baths: 3,
    area: "815 OR 625 sqft",
    amenities: ["24 Hrs Water Facility", "2 AC Point",]
  },
  {
    id: 102,
    areaLocation: " Rajpipla Chokadi Ankleshwar",
    title: "Satyam Residency",
    location: "Rajpipla Chowkadi NH-48,opp.Varsha Hotel",
    image: Satyam,
    type: "For Sale",
    isFeatured: true,
    imageCount: 6,
    listedDate: "2026-05-24",
    viewCount: 2890,
    propertyType: "residential",
    beds: 3,
    baths: 2,
    area: "551 sqft",
    amenities: ["Temple", "Garden", "Parking"]
  },
  {
    id: 103,
    areaLocation: " Andara Ankleshwar",
    title: "Nilkanth Varni Bungalow",
    location: "800 mtrs ahead of Gadkhol Patiya, Opp. Aiyappa Mandir, Ankleshwar.",
    image:Nilkanth,
    type: "For Sale",
    isFeatured: true,
    imageCount: 10,
    listedDate: "2026-05-24",
    viewCount: 5100,
    propertyType: "residential",
    beds: 3,
    baths: 3,
    area: "560 sqft",
    // amenities: [""]
  },
  {
    id: 104,
    areaLocation: "Ankleshwar-Bharuch Road",
    title: "Golden Nirvana 2/3 BHK ",
    location: "Near Golden Villa, Ankleshwar-Bharuch Road",
    image: Golden,
    type: "For Sale",
    isFeatured: false,
    imageCount: 7,
    listedDate: "2026-05-24",
    viewCount: 3560,
    propertyType: "residential",
    beds: 5,
    baths: 4,
    area: "850 sqft",
    // amenities: ["Private Garden", "Swimming Pool", "Servant Quarter", "Parking"]
  },
];

export default function FeaturedProperties() {
  const [visibleCount, setVisibleCount] = useState(6); // Show first 6 properties

  const [viewMode, setViewMode] = useState("grid"); // "grid" or "list"
  const [filterType, setFilterType] = useState("all"); // "all", "sale", "rent"
  const [propertyTypeFilter, setPropertyTypeFilter] = useState("all"); // "all", "residential", "domestic", "industrial", "land"
  const [searchTerm, setSearchTerm] = useState(""); // ✅ Search term
  const [sortBy, setSortBy] = useState("featured"); // "featured", "price-low", "price-high", "newest"

  // ✅ NEW: State for Area Location filter
  const [selectedArea, setSelectedArea] = useState("All");

  // ✅ NEW: Extract unique area locations from properties data
  const allAreaLocations = ["All", ...new Set(properties
    .map(property => property.areaLocation?.trim())
    .filter(area => area && area.trim() !== "")
    .map(area => area.trim())
  )];

  // Filter properties based on selected type
  const filteredProperties = properties.filter(property => {
    // ✅ NEW: First apply area location filter (if not 'All')
    if (selectedArea !== "All" && property.areaLocation?.trim() !== selectedArea) {
      return false;
    }

    // Sale/Rent filter
    if (filterType === "sale" && property.type !== "For Sale") return false;
    if (filterType === "rent" && property.type !== "For Rent") return false;

    // Property Type filter
    if (propertyTypeFilter !== "all" && property.propertyType !== propertyTypeFilter) return false;

    // ✅ Search filter
    if (searchTerm.trim() !== "") {
      const searchLower = searchTerm.toLowerCase();
      const matchesSearch =
        property.title.toLowerCase().includes(searchLower) ||
        property.location.toLowerCase().includes(searchLower) ||
        property.propertyType.toLowerCase().includes(searchLower);

      if (!matchesSearch) return false;
    }

    return true;
  });

  // Sort properties based on selected option
  const sortedProperties = [...filteredProperties].sort((a, b) => {
    switch (sortBy) {
      case "price-low":
        const priceA = parseInt(a.price ? a.price.replace(/[^0-9]/g, '') : 0);
        const priceB = parseInt(b.price ? b.price.replace(/[^0-9]/g, '') : 0);
        return priceA - priceB;

      case "price-high":
        const priceAHigh = parseInt(a.price ? a.price.replace(/[^0-9]/g, '') : 0);
        const priceBHigh = parseInt(b.price ? b.price.replace(/[^0-9]/g, '') : 0);
        return priceBHigh - priceAHigh;

      case "newest":
        return new Date(b.listedDate) - new Date(a.listedDate);

      case "featured":
      default:
        if (a.isFeatured && !b.isFeatured) return -1;
        if (!a.isFeatured && b.isFeatured) return 1;
        return new Date(b.listedDate) - new Date(a.listedDate);
    }
  });

  // ✅ Handle search input change with debounce
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // ✅ Clear all filters (updated to include area filter)
  const handleResetFilters = () => {
    setFilterType('all');
    setPropertyTypeFilter('all');
    setSearchTerm('');
    setSelectedArea('All'); // ✅ NEW: Reset area filter too
  };

  return (

<>


      <Helmet>
        <title>Properties for Sale & Rent in Ankleshwar | BG RealEstate360</title>
        <meta
          name="description"
          content="Browse industrial, residential and commercial properties in Ankleshwar with BG RealEstate360."
        />
      </Helmet>


    <section className="featured-section">

      <div className="featured-header">
        <div className="featured-header-left">
          <h2 className="featured-title">All Listing Properties</h2>
          <p className="featured-subtitle">Discover your dream property from our curated collection</p>
        </div>

        <div className="featured-header-right">
          <span className="featured-count">
            {sortedProperties.length} Properties Found
            {selectedArea !== "All" && ` in ${selectedArea}`} {/* ✅ NEW: Show area if filtered */}
          </span>
        </div>
      </div>

      {/* ✅ NEW: Area Location Filter - Add this ABOVE existing filters */}
      <div className="area-location-filter">
        <h3 className="area-filter-title">Filter by Area Location</h3>
        <div className="area-filter-buttons">
          {allAreaLocations.map(area => (
            <button
              key={area}
              className={`area-filter-btn ${selectedArea === area ? 'area-active' : ''}`}
              onClick={() => setSelectedArea(area)}
              type="button"
            >
              {area === "All" ? "All Areas" : area}
            </button>
          ))}
        </div>
      </div>

      {/* 🟡 EXISTING: Filters and Controls */}
      <div className="featured-controls">
        <div className="featured-filter-buttons">
          {/* Sale/Rent Filters */}
          <button
            className={`featured-filter-btn ${filterType === 'all' ? 'featured-active' : ''}`}
            onClick={() => setFilterType('all')}
          >
            All Properties
          </button>
          <button
            className={`featured-filter-btn ${filterType === 'sale' ? 'featured-active' : ''}`}
            onClick={() => setFilterType('sale')}
          >
            <FaFilter /> For Sale
          </button>
          <button
            className={`featured-filter-btn ${filterType === 'rent' ? 'featured-active' : ''}`}
            onClick={() => setFilterType('rent')}
          >
            <FaFilter /> For Rent
          </button>

          {/* Property Type Dropdown */}
          <div className="featured-dropdown featured-property-type-dropdown">
            <select
              value={propertyTypeFilter}
              onChange={(e) => setPropertyTypeFilter(e.target.value)}
              className="featured-filter-select"
            >
              <option value="all">All Property Types</option>
              <option value="residential">🏠 Residential</option>
              <option value="domestic">🏡 Domestic</option>
              <option value="industrial">🏭 Industrial</option>
              <option value="land">🌳 Land</option>
            </select>
          </div>

          {/* ✅ Search Input */}
          <div className="featured-search-container">
            <FaSearch className="featured-search-icon" />
            <input
              type="text"
              placeholder="Search by title, location or type..."
              value={searchTerm}
              onChange={handleSearchChange}
              className="featured-search-input"
              aria-label="Search properties by title, location or type"
            />
            {searchTerm && (
              <button
                className="featured-clear-search-btn"
                onClick={() => setSearchTerm("")}
                aria-label="Clear search"
              >
                ✕
              </button>
            )}
          </div>
        </div>

        {/* View Controls */}
        <div className="featured-view-controls">
          <div className="featured-sort-dropdown">
            <FaSortAmountDown className="featured-sort-icon" />
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="featured-sort-select"
            >
              <option value="featured">Featured First</option>
              <option value="newest">Newest First</option>
              <option value="price-low">Price: Low to High</option>
              <option value="price-high">Price: High to Low</option>
            </select>
          </div>

          <div className="featured-view-toggle">
            <button
              className={`featured-view-btn ${viewMode === 'grid' ? 'featured-active' : ''}`}
              onClick={() => setViewMode('grid')}
              aria-label="Grid view"
            >
              {/* Grid icon */}
            </button>
            <button
              className={`featured-view-btn ${viewMode === 'list' ? 'featured-active' : ''}`}
              onClick={() => setViewMode('list')}
              aria-label="List view"
            >
              <FaList />
            </button>
          </div>
        </div>
      </div>

      {/* Properties Grid/List */}
      <div className={`featured-container ${viewMode}`}>
        {sortedProperties.slice(0, visibleCount).map((item) => (
          <PropertyCard key={item.id} data={item} />
        ))}

      </div>

      {/* View More Button */}
      {visibleCount < sortedProperties.length && (
        <div className="featured-view-more-section">
          <button
            className="featured-view-more-btn"
            onClick={() => setVisibleCount(prev => prev + 6)}
          >
            View More Properties
          </button>
        </div>
      )}


      {/* No Results Message */}
      {sortedProperties.length === 0 && (
        <div className="featured-no-results">
          <h3>No Properties Found</h3>
          <p>Try changing your filters or check back later for new listings.</p>
          <button
            className="featured-reset-filters-btn"
            onClick={handleResetFilters}
          >
            Reset All Filters
          </button>
        </div>
      )}
    </section>


</>
  );
}